<script setup lang="ts">
import { useCuratorDisplayedPills } from '~/composables/useCuratorDisplayedPills'

import type { AvailableInfluencerBadges as availableTags } from '~/enums/AvailableInfluencerBadges'
import type { Influencer, StatsV3Influencer } from '~/types/influencer'

export type BadgeName = (typeof availableTags)[number]

type Props = {
  influencer: StatsV3Influencer | Influencer
  badgeName?: BadgeName | ''
}

const props = withDefaults(defineProps<Props>(), {
  badgeName: '',
})

const { getDisplayedBadge } = useCuratorDisplayedPills(props.influencer)
const displayedBadge = computed(() => getDisplayedBadge(props.badgeName))

type Slots = {
  default(payload: (typeof displayedBadge)['value']): any
}

defineSlots<Slots>()
</script>

<template>
  <div class="badgeIcon">
    <slot v-if="displayedBadge.name" v-bind="displayedBadge" />
  </div>
</template>
